/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */
import React, { useState, useEffect, useRef, useImperativeHandle } from 'react';
import { TextField } from "@mui/material";
import SearchIcon from "../../../../../../assets/images/icon_actions/Search Icon.svg";
import ClearIcon from "../../../../../../assets/images/icon_actions/Clear Icon.svg";
import { getRequest } from '../../../../../../helpers/axiosClient';
import { Image } from "antd";
import { NavLink } from "react-router-dom";
import usePrevious from "../../../../../Shared/components/Previous";


export const BarCodeComponent = React.forwardRef((props, ref) => {
    const { classes, clsx, handleGridClick } = props;

    const [barcodeValue, setBarcodeValue] = useState('');
    const [error, setError] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [loading, setLoading] = useState(false);
    const prevBarcodeValue = usePrevious(barcodeValue);
    const timeoutRef = useRef(null);
    const barcodeRef = useRef(null);

    const handleBarcodeSearch = (value) => {
        setError('');
        try {
            let filter = { where: { ["and"]: [{ status: 'ACTIVE' }, { barcode: value }, { ["or"]: [{ transType: { eq: null } }, { transType: { eq: 'SALES' } }] }] } };
            let response = getRequest(`${process.env.REACT_APP_API_URL}/client-products?filter=${encodeURIComponent(JSON.stringify(filter))}`);
            response.then(payload => {
                // Handle the fetched data here
                let data = payload.data;
                if (data && data?.length) {
                    handleGridClick(data[0], 1);
                    setBarcodeValue('');
                    setLoading(false);
                } else {
                    setError('No Products Avaliable');
                    setLoading(false);
                }
            }).catch(error => {
                // Handle any errors
                setError('No Products Avaliable');
                setLoading(false);
            })
        } catch (error) {
            setError('No Products Avaliable');
            setLoading(false);
        }
    }

    useImperativeHandle(ref, () => ({
        onFocus() {
            onFocus();
        }
    }));

    const onFocus = () => {
        setTimeout(() => {
            barcodeRef.current.focus()
        });
    }

    useEffect(() => {
        onFocus();
    }, []);


    useEffect(() => {
        if (prevBarcodeValue !== undefined && barcodeValue && barcodeValue.length > 3 && prevBarcodeValue !== barcodeValue) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(() => {
                timeoutRef.current = null;
                setLoading(true);
                handleBarcodeSearch(barcodeValue);
            }, 500);
        }
    }, [barcodeValue]);

    return (
        <div className={classes.positionRelative} style={{ paddingBottom: 10 }}>
            <div className={clsx(classes.searchAnimation, classes.customerLabelNone, { [classes.iconAnimation]: iconAnimation || barcodeValue !== '' })}>
                <TextField autoComplete='one-time-code'
                    placeholder={'Please Enter or Scan Barcode'}
                    type='text'
                    inputRef={barcodeRef}
                    value={barcodeValue}
                    onChange={(e) => setBarcodeValue(e.target.value)}
                    className={classes.comInput}
                    variant={'standard'}
                    fullWidth
                    onFocus={(e) => {
                        setIconAnimation(true);
                    }}
                    onBlur={() => setIconAnimation(false)}
                />
                <Image src={SearchIcon} preview={false} />
                {
                    barcodeValue && <NavLink to="#" onClick={() => { setBarcodeValue(''); setError('') }} className={clsx(classes.searchClear, { [classes.loadingA]: loading })}>
                        <Image
                            src={ClearIcon}
                            preview={false}
                        />
                    </NavLink>
                }
            </div>
            {
                error && <div className={classes.errorBarcode}>{error}</div>
            }
        </div >
    )
})